module.exports = __webpack_public_path__ + "static/media/hourglassMini.35c74275.svg";